import create from "zustand";
import { TalhaoHistorico } from "../interfaces/Talhao";

interface ModalState {
  id?: string;
  ids?: string[];
  code: number;
  talhaoId: string;
  names?: string[];
  isOpen: boolean;
  menuOption: string;
  isCancelOperationModal: boolean;
  isAnteciparOuProrrogarModal: boolean;
  isEncerrarOuReabrirModal: boolean;
  codigoEncerrarOuReabrirModal: number | null;
  anteciparOuProrrogar: {
    name: string;
    data: string;
  };
  isModalHistoricoOperacao: boolean;
  isModalCadastroOperacao: boolean;
  planoOperacionalOperacaoTalhao: TalhaoHistorico | null;
  showLegends: boolean;
  planejamentoOperacionalPorTalhao: any;
  isOpenModalVinculo: boolean;
  listPlanoOperacionalTalhao: any[];
  operacaoVinculadaItem: any;
 
  setId: (args: string) => void;
  setIds: (args: string[]) => void;
  setCode: (args: number) => void;
  setTalhaoId: (args: string) => void;
  setNames: (args: string[]) => void;
  setIsOpen: (args: boolean) => void;
  setMenuOption: (args: string) => void;
  setIsCancelOperationModal: (args: boolean) => void;
  setIsAnteciparOuProrrogarModal: (args: boolean) => void;
  setAnteciparOuProrrogar: (args: any) => void;
  setIsEncerrarOuReabrirModal: (args: any) => void;
  setIsModalHistoricoOperacao: (args: boolean) => void;
  setIsModalCadastroOperacao: (args: boolean) => void;
  setPlanoOperacionalOperacaoTalhao: (args: TalhaoHistorico | null) => void;
  setShowLegends: (args: boolean) => void;
  setPlanejamentoOperacionalPorTalhao: (args: any) => void;
  setIsOpenModalVinculo: (args: boolean) => void;
  setListPlanoOperacionalTalhao: (args: any) => void;
  setOperacaoVinculadaItem: (args: any) => void;
  setCodigoEncerrarOuReabrirModal: (args: number | null) => void;
}

const useModal = create<ModalState>((set) => ({
  id: '',
  ids: [],
  code: 0,
  talhaoId: '',
  names: [],
  isOpen: false,
  menuOption: "operacoes",
  isCancelOperationModal: false,
  isAnteciparOuProrrogarModal: false,
  isEncerrarOuReabrirModal: false,
  codigoEncerrarOuReabrirModal: null,
  anteciparOuProrrogar: {
    name: "",
    data: "",
  },
  isModalHistoricoOperacao: false,
  isModalCadastroOperacao: false,
  planoOperacionalOperacaoTalhao: null,
  showLegends: false,
  planejamentoOperacionalPorTalhao: null,
  isOpenModalVinculo: false,
  listPlanoOperacionalTalhao: [],
  operacaoVinculadaItem: null,

  setId: (id) => {
    set(state => ({ id }));
  },
  setIds: (ids) => {
    set(state => ({ ids }));
  },

  setCode: (code) => {
    set(state => ({ code }));
  },
  setTalhaoId: (talhaoId) => {
    set(state => ({ talhaoId }));
  },
  setNames: (names) => {
    set(state => ({ names }));
  },
  setIsOpen: (isOpen) => {
    set(state => ({ isOpen }));
  },
  setMenuOption: (menuOption) => {
    set(state => ({ menuOption }));
  },
  setIsCancelOperationModal: (isCancelOperationModal) => {
    set(state => ({ isCancelOperationModal }));
  },

  setIsAnteciparOuProrrogarModal: (isAnteciparOuProrrogarModal) => {
    set(state => ({ isAnteciparOuProrrogarModal }));
  },

  setAnteciparOuProrrogar: (anteciparOuProrrogar) => {
    set(state => ({ anteciparOuProrrogar }));
  },

  setIsModalHistoricoOperacao: (isModalHistoricoOperacao) => {
    set(state => ({ isModalHistoricoOperacao }));
  },

  setIsModalCadastroOperacao: (isModalCadastroOperacao) => {
    set(state => ({ isModalCadastroOperacao }));
  },

  setPlanoOperacionalOperacaoTalhao: (planoOperacionalOperacaoTalhao) => {
    set(state => ({ planoOperacionalOperacaoTalhao }));
  },

  setShowLegends: (showLegends) => {
    set(state => ({ showLegends }));
  },

  setPlanejamentoOperacionalPorTalhao: (planejamentoOperacionalPorTalhao) => {
    set(state => ({ planejamentoOperacionalPorTalhao }));
  },

  setIsOpenModalVinculo: (isOpenModalVinculo) => {
    set(state => ({ isOpenModalVinculo }));
  },

  setListPlanoOperacionalTalhao: (listPlanoOperacionalTalhao) => {
    set(state => ({ listPlanoOperacionalTalhao }));
  },

  setOperacaoVinculadaItem: (operacaoVinculadaItem) => {
    set(state => ({ operacaoVinculadaItem }));
  },

  setIsEncerrarOuReabrirModal: (isEncerrarOuReabrirModal) => {
    set(state => ({ isEncerrarOuReabrirModal }));
  },

  setCodigoEncerrarOuReabrirModal: (codigoEncerrarOuReabrirModal) => {
    set(state => ({ codigoEncerrarOuReabrirModal }));
  },
 
}));

export default useModal;
